import Particles from "react-tsparticles"
import { Container } from "./styles"
import { Hero } from "../Hero/Hero"
import { About } from "../About/About";
import { Contact } from "../Contact/Contact";
import { Portfolio } from "../Portfolio/Portfolio";
import { CaseStudy } from "../CaseStudy/CaseStudy";

import jsIcon from "../../assets/js-icon.svg";
import nodeIcon from "../../assets/node-icon.svg";
import reactIcon from "../../assets/react-icon.svg";
import typescriptIcon from "../../assets/typescript-icon.svg";
import pythonIcon from "../../assets/python-icon.svg";
import kotlinIcon from "../../assets/kotlin-icon.svg";
import swiftIcon from "../../assets/swift-icon.svg";
import appleIcon from "../../assets/apple-icon.svg";
import androidIcon from "../../assets/android-icon.svg";
import githubIcon from "../../assets/github-icon.svg";
import firebaseIcon from "../../assets/firebase-icon.svg";
import supabaseIcon from "../../assets/supabase-icon.svg";

const PARTICLE_ICONS = [
  reactIcon,
  typescriptIcon,
  jsIcon,
  nodeIcon,
  pythonIcon,
  kotlinIcon,
  swiftIcon,
  appleIcon,
  androidIcon,
  githubIcon,
  firebaseIcon,
  supabaseIcon,
].map((src) => ({ src, width: 20, height: 20 }));

// Computed once: the floating icons are decorative motion, so they are skipped entirely
const prefersReducedMotion =
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export function Main() {
  return (

    <Container>
      {!prefersReducedMotion && (<Particles
        id="tsparticles"
        options={{
          "fullScreen": {
            "enable": true,
            // Sits behind the content sections, which are raised to z-index 1 in ./styles
            "zIndex": 0
          },
          "detectRetina": true,
          "fpsLimit": 60,
          "interactivity": {
            "events": {
              "onClick": {
                "enable": false,
                "mode": "push"
              },
              "onDiv": {
                "elementId": "repulse-div",
                "enable": false,
                "mode": "repulse"
              },
              "onHover": {
                "enable": false,
                "mode": "bubble",
                "parallax": {
                  "enable": false,
                  "force": 60,
                  "smooth": 10
                }
              },
              "resize": true
            },
            "modes": {
              "bubble": {
                "distance": 400,
                "duration": 2,
                "opacity": 0.8,
                "size": 2,
              },
              "connect": {
                "distance": 80,
                "lineLinked": {
                  "opacity": 0.5
                },
                "radius": 60
              },
              "grab": {
                "distance": 400,
                "lineLinked": {
                  "opacity": 1
                }
              },
              "push": {
                "quantity": 2
              },
              "remove": {
                "quantity": 2
              },
              "repulse": {
                "distance": 200,
                "duration": 0.4
              }
            }
          },
          "particles": {
            "color": {
              "value": "#ffffff"
            },
            "lineLinked": {
              "blink": false,
              "color": "#000",
              "consent": false,
              "distance": 150,
              "enable": false,
              "opacity": 0.4,
              "width": 1
            },
            "move": {
              "attract": {
                "enable": false,
                "rotate": {
                  "x": 600,
                  "y": 1200
                }
              },
              "bounce": false,
              "direction": "none",
              "enable": true,
              "outMode": "out",
              "random": false,
              "speed": 1.2,
              "straight": false
            },
            "number": {
              "density": {
                "enable": true,
                "area": 800
              },
              "limit": 14,
              "value": 12,
            },
            "opacity": {
              "animation": {
                "enable": true,
                "minimumValue": 0.15,
                "speed": 1,
                "sync": false
              },
              "random": true,
              "value": 0.55
            },
            "rotate": {
              "animation": {
                "enable": true,
                "speed": 5,
                "sync": false
              },
              "direction": "random",
              "random": true,
              "value": 0
            },
            "shape": {
              "character": {
                "fill": false,
                "font": "Verdana",
                "style": "",
                "value": "*",
                "weight": "400"
              },
              "image": PARTICLE_ICONS,
              "polygon": {
                "sides": 5
              },
              "stroke": {
                "color": "#000000",
                "width": 0
              },
              "type": "image"
            },
            "size": {
              "animation": {
                "enable": false,
                "minimumValue": 0.1,
                "speed": 40,
                "sync": false
              },
              "random": false,
              "value": 16
            }
          },
          "polygon": {
            "draw": {
              "enable": false,
              "lineColor": "#ffffff",
              "lineWidth": 0.5
            },
            "move": {
              "radius": 10
            },
            "scale": 1,
            "url": ""
          },
          "background": {
            "image": "",
            "position": "50% 50%",
            "repeat": "no-repeat",
            "size": "cover"
          }
        }}
      />)}
      <Hero></Hero>
      <About></About>
      <Portfolio></Portfolio>
      <CaseStudy></CaseStudy>
      <Contact></Contact>
    </Container>
  );
}